import { render, staticRenderFns } from "./Sentencas.vue?vue&type=template&id=69a702bc&"
import script from "./Sentencas.vue?vue&type=script&lang=js&"
export * from "./Sentencas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports